import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { get as _get, isEqual as _isEqual, map as _map } from "lodash";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import Helmet from "react-helmet";

import { showAlertMessage, Select, RenderTableHeaderValue, RenderTableCellValue, CustomModal, ConfirmBox } from "../../../resusableComponents/common/formElements";
import { hasAccess } from "../../../resusableComponents/hoc/AccessManagement";
import { withRouter } from "../../../resusableComponents/hoc/withRouter";
import ReactDataTable from "../../../resusableComponents/common/ReactDataTable";
import AddOrUpdateTemplate from "./component/AddOrUpdateTemplate";

import { doGetClientTemplateList, deleteClientTemplate } from "../../../redux/services/clientTemplates";
import { doGetAgencyList, doGetClientList } from "../../../redux/services/userMangement";
import { updatePageLevelLoadingState } from "../../../redux/actions/application";

class ClientTemplates extends Component {

  constructor(props) {
    super(props);

    this.state = {
      agencyList: [],
      selectedAgency: null,
      clientList: [],
      templateList: [],
      selectedClient: null,
      activeRequestCount: 0,
      showAddOrUpdateModal: false,
      selectedTemplateId: null,
      isCloneMode: false,
      showDeleteTemplateConfirmBox: false,
    };

    this.columns = [
      {
        name: (<RenderTableHeaderValue sortable={true} value={props.intl.formatMessage({ id: "client_templates.table.name", defaultMessage: "Template Name" })} />),
        selector: (row) => (_get(row, "template_name", "")),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "template_name", "")} tooltip={true} />),
        sortable: false,
        grow: 2
      },
      {
        name: (<RenderTableHeaderValue sortable={true} value={props.intl.formatMessage({ id: "client_templates.table.agency", defaultMessage: "agency" })} />),
        selector: (row) => (_get(row, "agency_name", "")),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "agency_name", "")} tooltip={true} />),
        sortable: false
      },
      {
        name: (<RenderTableHeaderValue sortable={true} value={props.intl.formatMessage({ id: "client_templates.table.client", defaultMessage: "client" })} />),
        selector: (row) => (_get(row, "client", "")),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "client", "")} tooltip={true} />),
        sortable: false
      },
      {
        name: (<RenderTableHeaderValue sortable={true} value={props.intl.formatMessage({ id: "client_templates.table.created_by", defaultMessage: "created_by" })} />),
        selector: (row) => (_get(row, "created_by", "")),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "created_by", "")} tooltip={true} />),
        sortable: false
      },
      {
        name: (<RenderTableHeaderValue sortable={true} value={props.intl.formatMessage({ id: "client_templates.table.created_at", defaultMessage: "created_at" })} />),
        selector: (row) => (_get(row, "created_at", "")),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "created_at", "")} tooltip={true} />),
        sortable: false
      },
      {
        name: (<RenderTableHeaderValue sortable={true} value={props.intl.formatMessage({ id: "client_templates.table.actions", defaultMessage: "Actions" })} />),
        selector: (row) => {
          const templateId = _get(row, "template_id", "");

          return hasAccess("admin", "client-templates", ["update-template", "delete-template"], "OR") ? (
            <Dropdown>
              <Dropdown.Toggle as="a" variant="link" className="fw-normal dropdown-toggle-no cursor-pointer">
                <img src={require("../../../assets/icons/icon-three-dot.svg").default} className="img-fluid" alt="img" />
              </Dropdown.Toggle>

              <Dropdown.Menu as="ul" className="dropdown-menu">
                {hasAccess("admin", "client-templates", ["update-template"]) && (
                  <Dropdown.Item className="dropdown-item d-block waves-effect text-capitalize" onClick={() => this.setState({ showAddOrUpdateModal: true, selectedTemplateId: templateId, isCloneMode: false })} >
                    <FormattedMessage id="user_management.client.list.action.edit" defaultMessage="edit" />
                  </Dropdown.Item>
                )}
                {hasAccess("admin", "client-templates", ["create-template"]) && (
                  <Dropdown.Item className="dropdown-item d-block waves-effect text-capitalize" onClick={() => this.setState({ showAddOrUpdateModal: true, selectedTemplateId: templateId, isCloneMode: true })}>
                    <FormattedMessage id="user_management.client.list.action.clone" defaultMessage="clone" />
                  </Dropdown.Item>
                )}
                {hasAccess("admin", "client-templates", ["delete-template"]) && (
                  <Dropdown.Item className="dropdown-item d-block waves-effect text-capitalize" onClick={() => this.setState({ showDeleteTemplateConfirmBox: true, selectedTemplateId: templateId })}>
                    <FormattedMessage id="user_management.client.list.action.delete" defaultMessage="delete" />
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          ) : (<></>)
        },
        sortable: false,
        width: "80px",
        center: "true",
      },
    ];
  };

  componentDidMount() {
    this._fetchAgencyList();
    this._fetchClientTemplateList();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_isEqual(prevState.selectedAgency, this.state.selectedAgency)) {
      this._fetchClientList();
    }

    if (
      !_isEqual(prevState.selectedAgency, this.state.selectedAgency) ||
      !_isEqual(prevState.selectedClient, this.state.selectedClient) ||
      (!_isEqual(prevState.refreshTable, this.state.refreshTable) && (_get(this.state, "refreshTable", false) === true))
    ) {
      this._fetchClientTemplateList();
    }
  }

  _incrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = (_get(prevState, "activeRequestCount", 0) + 1);
      if (nextCount === 1 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(true); }
      return { activeRequestCount: nextCount };
    });
  }

  _decrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = Math.max(0, _get(prevState, "activeRequestCount", 0) - 1);
      if (nextCount === 0 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(false); }
      return { activeRequestCount: nextCount };
    });
  }

  _fetchAgencyList = async () => {
    try {
      this._incrementLoader();

      const response = await doGetAgencyList({ dropdown_flag: 1 });

      if ((response.flag || false) === true) {
        this.setState({ agencyList: _get(response, "data.responseData.agency_list", []), clientList: [], selectedAgency: null, selectedClient: null });
      } else {
        showAlertMessage((_get(response, "message", "Something went wrong while fetching agency list.")));
        this.setState({ agencyList: [], clientList: [], selectedAgency: null, selectedClient: null });
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching agency list."));

    } finally {
      this._decrementLoader();
    }
  }

  _fetchClientList = async () => {
    const { selectedAgency } = this.state;

    try {
      this._incrementLoader();

      const response = await doGetClientList({ agency_id: _get(selectedAgency, "id", null), dropdown_flag: 1 });

      if ((response.flag || false) === true) {
        this.setState({ clientList: _get(response, "data.responseData.client_list", []), selectedClient: null });
      } else {
        showAlertMessage((_get(response, "message", "Something went wrong while fetching client list.")));
        this.setState({ clientList: [], selectedClient: null });
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching client list."));

    } finally {
      this._decrementLoader();
    }
  }

  _fetchClientTemplateList = async () => {
    const { selectedAgency, selectedClient } = this.state;

    try {
      this._incrementLoader();

      const response = await doGetClientTemplateList({
        agency_id: _get(selectedAgency, "id", null),
        client_ids: _map(selectedClient, "id"),
      });

      if ((response.flag || false) === true) {
        this.setState({ templateList: _get(response, "data.responseData", []), refreshTable: false });
      } else {
        showAlertMessage((_get(response, "message", "Something went wrong while fetching client templates list.")));
        this.setState({ templateList: [], refreshTable: false });
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching client templates list."));

    } finally {
      this._decrementLoader();
    }
  }

  _handleReset = () => {
    this.setState({
      selectedAgency: null,
      clientList: [],
      templateList: [],
      selectedClient: null
    });
  }

  _handleDeleteTemplate = async () => {
    const { intl } = this.props;
    const { selectedTemplateId } = this.state;

    if (!selectedTemplateId) {
      showAlertMessage(intl.formatMessage({ id: "error.select", defaultMessage: "Please select {field}." }, {
        field: intl.formatMessage({ id: "client_templates.client_template", defaultMessage: "client template" })
      }));
      return false;
    }

    try {
      this._incrementLoader();

      const response = await deleteClientTemplate((selectedTemplateId || null));

      if ((response.flag || false) === true) {

        showAlertMessage(_get(response, "data.responseMessage", "Client template deleted successfully."), "success");

        this._fetchClientTemplateList();
      } else {
        showAlertMessage(_get(response, "data.responseMessage", "Something went wrong while deleting client template."));
      }
    } catch (err) {
      showAlertMessage(err.message || "Something went wrong while deleting client template.");
    } finally {
      this.setState({ selectedTemplateId: null, showDeleteTemplateConfirmBox: false });

      this._decrementLoader();
    }
  }

  _renderAddOrUpdateTemplate = () => {
    const { intl } = this.props;
    const { showAddOrUpdateModal, selectedTemplateId, isCloneMode, agencyList } = this.state;

    if (!showAddOrUpdateModal) { return null; }

    let modalTitle;
    if (isCloneMode) {
      modalTitle = intl.formatMessage({ id: "client_template.modal.clone_title", defaultMessage: "Clone Client Template" });
    } else if (!selectedTemplateId) {
      modalTitle = intl.formatMessage({ id: "client_template.modal.create_title", defaultMessage: "Create Client Template" });
    } else {
      modalTitle = intl.formatMessage({ id: "client_template.modal.edit_title", defaultMessage: "Edit Client Template" });
    }

    return (
      <CustomModal
        isOpen={(showAddOrUpdateModal || false)}
        size="xl"
        modalTitle={modalTitle}
        onHide={() => this.setState({ showAddOrUpdateModal: false, selectedTemplateId: null, isCloneMode: false })}
        onClose={() => this.setState({ showAddOrUpdateModal: false, selectedTemplateId: null, isCloneMode: false })}
      >

        <AddOrUpdateTemplate
          showAddOrUpdateModal={(showAddOrUpdateModal || false)}
          filterAgencyList={(agencyList || [])}
          editTemplateId={(selectedTemplateId || null)}
          isCloneMode={(isCloneMode || false)}
          setState={(args) => this.setState(args)}
        />

      </CustomModal>
    );
  }

  _renderTemplateList = () => {
    const { intl } = this.props;
    const { agencyList, clientList, selectedAgency, selectedClient, templateList } = this.state;

    return (
      <>
        <table className="table mb-0">
          <thead className="table-light">
            <tr>
              <th scope="col">
                <div className="row">
                  <div className="col-lg-3">
                    <Select
                      className="form-custom-select"
                      placeholder={intl.formatMessage({ id: "client_templates.agency", defaultMessage: "Agency" })}
                      options={(agencyList || [])}
                      value={(selectedAgency || null)}
                      getOptionLabel={(option) => (option.agency_name)}
                      getOptionValue={(option) => (option.id)}
                      onChange={(selected) => this.setState({ selectedAgency: selected, clientList: [], selectedClient: null })}
                      isMulti={false}
                    />
                  </div>
                  <div className="col-lg-3">
                    <Select
                      className="form-custom-select"
                      placeholder={intl.formatMessage({ id: "client_templates.client", defaultMessage: "Client" })}
                      options={(clientList || [])}
                      value={(selectedClient || null)}
                      getOptionLabel={(option) => (option.client_name)}
                      getOptionValue={(option) => (option.id)}
                      onChange={(selected) => this.setState({ selectedClient: selected })}
                    />
                  </div>
                  <div className="ms-auto col-lg-auto">
                    <button className="input-group-text btn btn-dark text-capitalize" onClick={() => this._handleReset()}>
                      <FormattedMessage id="btn.reset" defaultMessage="reset" />
                    </button>

                    {hasAccess("admin", "client-templates", ["create-template"]) && (
                      <button className="input-group-text ms-2 btn btn-primary text-capitalize" onClick={() => this.setState({ showAddOrUpdateModal: true, selectedTemplateId: null })}>
                        <FormattedMessage id="client_template.add_new_template" defaultMessage="add new template" />
                      </button>
                    )}
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </table>

        {hasAccess("admin", "client-templates", ["client-templates-list"]) && (
          <ReactDataTable
            columns={this.columns}
            data={(templateList || [])}
            pagination={false}
            totalRecords={(templateList || []).length}
          />
        )}
      </>
    );
  }

  render() {
    const { intl } = this.props;
    const { showDeleteTemplateConfirmBox } = this.state;

    return (
      <>
        <Helmet>
          <title>
            {intl.formatMessage({ id: "funnel.client_templates", defaultMessage: "Client Templates: Funnel Fuel" })}
          </title>
        </Helmet>

        <div className="content-wrapper">
          <div className="container-fluid flex-grow-1 px-6 py-6">
            <div className="row">
              <div className="col-lg-12">

                <h1 className="heading-04 fw-semibold text-dark-35 text-uppercase mb-5">
                  <FormattedMessage id="client_templates.title" defaultMessage="client templates" />
                </h1>

              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    {this._renderTemplateList()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this._renderAddOrUpdateTemplate()}

        {hasAccess("admin", "client-templates", ["delete-template"]) && (
          <ConfirmBox
            onConfirm={() => this._handleDeleteTemplate()}
            isOpen={(showDeleteTemplateConfirmBox || false)}
            onClose={() => this.setState({ showDeleteTemplateConfirmBox: false, selectedTemplateId: null })}
            content={intl.formatMessage({ id: "confirm.delete_template", defaultMessage: "Are you sure you want to delete selected template?" })}
          />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePageLevelLoadingState: (data) => dispatch(updatePageLevelLoadingState(data)),
});

export default connect(null, mapDispatchToProps)(withRouter(injectIntl(ClientTemplates)));
